import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import ModalMasterDetailView from "../../../components/modal/ModalMasterDetailView";
import { withModalSizeContext } from "../../../components/modal/ModalSizeContext";
import Dimensions from "../../../constants/styles/dimensions";
import { calendarOperations } from "../../../modules/definition/calendar";
import { PropTypeShapes } from "../../../types";
import CalendarSettingsEraDetailView from "./CalendarSettingsEraDetailView";
import CalendarSettingsEraTopRowView from "./CalendarSettingsEraTopRowView";

const CalendarSettingsEraTab = props => {
  const items = props.listItems(props.eras).map(era => ({
    ...era,
    canDelete: era.value !== 0 && era.value !== props.eras.count() - 1
  }));

  const minHeight = props.maxHeight - Dimensions.MODAL_MASTER_DETAIL_TOP_MARGIN;

  return (
    <div className="weekdayTabWrapper" style={{ minHeight: `${minHeight}px` }}>
      <CalendarSettingsEraTopRowView
        ignoreEras={props.ignoreEras}
        leapCycles={props.leapCycles}
        onChangeIgnoreEras={props.onChangeIgnoreEras}
        onChangeLeapCycles={props.onChangeLeapCycles}
        canEditDateData={props.canEditDateData}
      />
      <ModalMasterDetailView
        disabled={props.ignoreEras}
        items={items}
        onAddClick={props.canEditDateData ? props.onAddEra : null}
        onDeleteClick={props.canEditDateData ? props.onRemoveEra : null}
        canEditDateData={props.canEditDateData}
        allowDrag={props.canEditDateData}
        onMoveItemAtIndex={props.onMoveEra}
        lockTopItemForDrag={true}
        lockBottomItemForDrag={true}
        backText="Eras"
        itemsUseIndexAsId={true}
        disableMinHeight={true}
        //#!if iOS === true
// onDoneClick={props.onDoneClick}
        //#!endif
      >
        <CalendarSettingsEraDetailView {...props} />
      </ModalMasterDetailView>
    </div>
  );
};

CalendarSettingsEraTab.propTypes = {
  ignoreEras: PropTypes.bool.isRequired,
  leapCycles: ImmutablePropTypes.listOf(PropTypes.number).isRequired,
  eras: ImmutablePropTypes.listOf(PropTypeShapes.era).isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onChangeIgnoreEras: PropTypes.func.isRequired,
  onChangeLeapCycles: PropTypes.func.isRequired,
  onAddEra: PropTypes.func.isRequired,
  onMoveEra: PropTypes.func.isRequired,
  onRemoveEra: PropTypes.func.isRequired,
  onEraNameChange: PropTypes.func.isRequired,
  onEraShortNameChange: PropTypes.func.isRequired,
  onEraDurationChange: PropTypes.func.isRequired,
  onEraIsBackwardsChange: PropTypes.func.isRequired,
  onEraHasLeapYearsChange: PropTypes.func.isRequired,
  onEraLeapOffsetChange: PropTypes.func.isRequired,
  listItems: PropTypes.func.isRequired,
  canEditDateData: PropTypes.bool.isRequired,
  //#!if iOS === true
// onDoneClick: PropTypes.func.isRequired,
  //#!endif

  // From ModalSizeContext
  maxHeight: PropTypes.number.isRequired
};

const mapDispatchToProps = (_dispatch, props) => {
  // Note: We are always using dispatchLocal here so that the action only travels
  // back to the Settings Modal.
  // Changes are committed to the root store only when the dialog is confirmed.
  return {
    onChangeIgnoreEras: ignoreEras => {
      props.dispatchLocal(calendarOperations.changeIgnoreEras(ignoreEras));
    },
    onChangeLeapCycles: leapCycles => {
      props.dispatchLocal(calendarOperations.changeLeapCycles(leapCycles));
    },
    onAddEra: index => {
      props.dispatchLocal(
        calendarOperations.addEraAtIndex(
          _.isNil(index)
            ? props.eras.size - 1
            : index === 0
              ? 1
              : index >= props.eras.size - 1 || index < 0
                ? props.eras.size - 1
                : index + 1
        )
      );
    },
    onMoveEra: (fromIndex, toIndex) => {
      props.dispatchLocal(calendarOperations.moveEra(fromIndex, toIndex));
    },
    onRemoveEra: index => {
      props.dispatchLocal(calendarOperations.deleteEraAtIndex(index));
    },
    onEraNameChange: (index, name) => {
      props.dispatchLocal(calendarOperations.editEraName(index, name));
    },
    onEraShortNameChange: (index, name) => {
      props.dispatchLocal(calendarOperations.editEraShortName(index, name));
    },
    onEraDurationChange: (index, duration) => {
      props.dispatchLocal(calendarOperations.editEraDuration(index, duration));
    },
    onEraIsBackwardsChange: (index, isBackwards) => {
      props.dispatchLocal(calendarOperations.editEraIsBackwards(index, isBackwards));
    },
    onEraHasLeapYearsChange: (index, hasLeapYears) => {
      props.dispatchLocal(calendarOperations.editEraHasLeapYears(index, hasLeapYears));
    },
    onEraLeapOffsetChange: (index, offset) => {
      const num = _.isNumber(offset) ? Math.floor(offset) : 0;
      props.dispatchLocal(calendarOperations.editEraLeapOffset(index, num));
    }
  };
};

export default withModalSizeContext(connect(null, mapDispatchToProps)(CalendarSettingsEraTab));
